import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import { FC } from "react"
import { DeleteIconButton } from "src/components/ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "src/components/ui/iconButtons/EditIconButton"
import { IContactCategory } from "src/domain/entities"

export const ContactCategoryListView: FC<{
	list: IContactCategory[]
	onUpdate: (contactCategory: IContactCategory) => void
	onDelete: (contactCategory: IContactCategory) => void
}> = ({ list, onUpdate, onDelete }) => (
	<Table size={"sm"}>
		<Thead>
			<Tr>
				<Th>Name</Th>
				<Th>Note</Th>
				<Th isNumeric>Actions</Th>
			</Tr>
		</Thead>
		<Tbody>
			{list.map((contactCategory, i) => (
				<Tr key={i}>
					<Td>{contactCategory.name}</Td>
					<Td>{contactCategory.note}</Td>
					<Td isNumeric>
						<EditIconButton onClick={() => onUpdate(contactCategory)} />
						<DeleteIconButton onClick={() => onDelete(contactCategory)} />
					</Td>
				</Tr>
			))}
		</Tbody>
	</Table>
)
